import { Col, Row, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { InvoiceStatus, invoiceStatusKorean } from '../../modules/invoices';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import { TaskStatus, taskStatusKorean } from '../../modules/tasks';

const StyledDiv = styled.div`
  ${styledTable}
`;

export enum ToDoType {
  INVOICE = '0',
  TASK = '1',
}

export const todoTypeKorean = {
  '0': '청구서',
  '1': '업무',
} as const;

interface ToDoListComponentProps {
  todos: any[];
}

function ToDoListComponent({ todos }: ToDoListComponentProps) {
  const columns: ColumnsType<any> = [
    {
      title: '프로젝트명',
      align: 'left',
      dataIndex: ['project', 'name'],
      width: '25%',
    },
    {
      title: '종류',
      align: 'left',
      width: '7%',
      render: (value: any, record: any, index: any) =>
        todoTypeKorean[record.todoType as ToDoType],
    },
    {
      title: '상세내용',
      align: 'left',
      width: '40%',
      render: (value: any, record: any, index: any) => {
        let link = '';
        if (record.todoType === ToDoType.INVOICE) {
          link = `projects/${record.project.id}/invoices?invoiceId=${record.todoId}`;
        } else {
          link = `projects/${record.project.id}/tasks?taskId=${record.todoId}`;
        }
        return <Link to={link}>{record.description ?? ''}</Link>;
      },
    },
    {
      title: '상태',
      align: 'left',
      width: '8%',
      render: (value: any, record: any, index: any) => {
        if (record.todoType === ToDoType.INVOICE) {
          return invoiceStatusKorean[record.status as InvoiceStatus];
        } else {
          return taskStatusKorean[record.status as TaskStatus];
        }
      },
    },
  ];

  return (
    <StyledDiv>
      <Row>
        <Col span={24}>
          <Table<any>
            rowKey="id"
            columns={columns}
            dataSource={todos}
            pagination={false}
            locale={{
              triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
              triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
              cancelSort: '정렬을 취소하려면 클릭하세요.',
            }}
          />
        </Col>
      </Row>
    </StyledDiv>
  );
}

export default ToDoListComponent;
